import {Component, OnInit, ViewChild} from '@angular/core';
import {RestService} from '../../shared/service/rest.service';
import {MyProfileModel} from 'src/shared/model/UserProfile';

import {AuthServiceCustom, EmailRegex} from 'src/shared/service/auth.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {AbstractDataProvider} from '../AbstractDataProvider';
import {of, Subject, Subscription} from 'rxjs';
import {DynamicModalService} from '../ui-components/dynamic-modals/dynamic-modal.service';
import {ExecutionStatus} from 'src/shared/model/execution-status.enum';
import {JqueryDialogService} from '../ui-components/jquery-dialog/jquery-dialog.service';
import {ActivatedRoute} from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import {EditSecurityQuestionsComponent} from './edit-security-questions/edit-security-questions.component';
import {delay, finalize, switchMapTo, tap} from 'rxjs/operators';
import {getErrorMessageText} from '../helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss']
})
export class EditProfileComponent implements OnInit {
  @ViewChild('securityQuestions') securityQuestions: EditSecurityQuestionsComponent;

  userProfileEntity: MyProfileModel = new MyProfileModel();
  display = false;
  alertMessage: string;
  clientCode: string;
  logoImageUrl: string;
  IsElectronicMailSubscribed: boolean;
  public subjectOnClose: Subject<any>;
  userInfoConfigurationUserTypeWise: any = {};
  actionToPerform = '';
  userType: string;
  isCurrentUserProfile: boolean;
  isUserIdValid = true;
  private saveTimeout: number;
  private currentUserId: string;
  private logoutAfterAlertClose: boolean;

  constructor(
    public rest: RestService,
    private authService: AuthServiceCustom,
    private dynamicModalService: DynamicModalService,
    private route: ActivatedRoute,
    private ngxService: NgxUiLoaderService,
    private authOKTA: AuthService,
    private jqueryDialogService: JqueryDialogService,
    private abstractDataProvider: AbstractDataProvider) {
  }


  ngOnInit() {
    this.isCurrentUserProfile = this.route.snapshot.data.currentUserProfile || !this.authService.PreviousLoggedInUser;
    this.clientCode = this.authService.clientCode;
    this.userType = this.authService.UserType;
    this.getUserRelatedData();
    this.getTextAndVisiblityConfiguration();
  }

  tryScheduleSave() {
    // TODO: fix commented code
    // if (this.ngxService.getLoaders().master.foreground.default) {
    //   return;
    // }
    this.saveTimeout = window.setTimeout(() => {
      this.saveTimeout = null;
      this.save();
    });
  }


  getUserRelatedData() {
    this.userProfileEntity = JSON.parse(JSON.stringify(this.authService.currentUserProfileEntity));
    this.currentUserId = this.authService.currentUserProfileEntity.UserId;
    this.IsElectronicMailSubscribed = Boolean((this.authService.currentUserProfileEntity.IsElectronicMailSubscribed) as any === 'Y'); // 'Y' / 'N'
    this.userProfileEntity.ConfirmEmailAddress = this.userProfileEntity.EmailAddress;
  }

  getTextAndVisiblityConfiguration() {
    this.userInfoConfigurationUserTypeWise = this.authService.getTextAndVisiblityConfiguration(this.authService.UserType);
  }

  save(): void {
    this.actionToPerform = '';
    // Entities to save are: userProfileEntity & securityQuestionAnswer

    this.userProfileEntity.IsElectronicMailSubscribed = this.IsElectronicMailSubscribed ? 'Y' : 'N';

    if (!this.userProfileEntity.EmailAddress) {
      this.display = true;
      this.alertMessage = 'Email Address is required';
      return;
    }

    if (!this.userProfileEntity.ConfirmEmailAddress) {
      this.display = true;
      this.alertMessage = 'Confirm Email Address is required';
      return;
    }

    if (this.userProfileEntity.ConfirmEmailAddress && this.userProfileEntity.EmailAddress && this.userProfileEntity.ConfirmEmailAddress.toLowerCase() !== this.userProfileEntity.EmailAddress.toLowerCase()) {
      this.display = true;
      this.alertMessage = 'Confirm Email Address does not match';
      return;
    }

    if (!this.userProfileEntity.EmailAddress.match(EmailRegex)) {
      this.display = true;
      this.alertMessage = 'Email Address is invalid';
      return;
    }

    this.userProfileEntity.UserId = this.userProfileEntity.EmailAddress.toUpperCase();

    const oldEntity  = JSON.parse(JSON.stringify(this.authService.currentUserProfileEntity));
    const userNameChanged = oldEntity.UserId !== this.userProfileEntity.UserId && this.isCurrentUserProfile;

    // Make server call : In API method, add logic to not to update email id and password if record type is "U"
    this.abstractDataProvider.postData(this.userProfileEntity, 'api/Accounts/UpdateMyUserProfileInfo').subscribe(
      (posts: any) => {
        this.display = true;
        this.logoutAfterAlertClose = userNameChanged;

        if (userNameChanged) {
          this.alertMessage = posts.Data.AlertMsgs[0] + '<br>' + 'After changing your email you must login again.' ;
        } else {
          this.alertMessage = posts.Data.AlertMsgs[0];
        }
        if (posts.Data.status === ExecutionStatus.Success) {
          this.actionToPerform = 'closeDialog';
        }
      },
      error => {
        this.display = true;
        this.alertMessage = error.error && error.error.Message;
      }
    );
  }

  cancel() {
    this.close(false);
  }

  close(result: any = null) {
    if (this.subjectOnClose && this.subjectOnClose.observers.length > 0) {
      this.subjectOnClose.next(result);
      this.dynamicModalService.subject.next(null);
    } else {
      this.authService.navigateToUrl('home');
    }
  }


  onConfirm() {
    this.display = false;
    if (this.actionToPerform === 'closeDialog') {
      this.close(true);
      if (this.logoutAfterAlertClose) {
        this.authOKTA.logout({
          logoutParams: {
            returnTo: environment.logout // this.location.prepareExternalUrl('')
          }
        });
        
        this.authService.logout();
      }
    }
  }

  toUpperCaseInput(event: KeyboardEvent) {
    const input = (event.target as HTMLInputElement);
    input.value = input.value && input.value.toString().toUpperCase();
  }
}
